import React from 'react'

class BlogUtm extends React.Component {
  componentDidMount() {
    const self = this
    const els = document.querySelectorAll('a[data-blogutm]')

    els.forEach((el) => {
      const query = self.queryToReturn(el.dataset.blogutm)
      el.href += query
    })
  }

  getParameterByName(name, url = window.location.href) {
    const newName = name.replace(/[\[\]]/g, '\\$&')
    const regex = new RegExp(`[?&]${newName}(=([^&#]*)|&|#|$)`)
    const results = regex.exec(url)

    if (!results) return null
    if (!results[2]) return ''
    return decodeURIComponent(results[2].replace(/\+/g, ' '))
  }

  queryToReturn(pos) {
    let utmParamToAppendToLink = ''
    const utmParams = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content']

    for (let i = 0; i < utmParams.length; i++) {
      const param = utmParams[i]
      const utmVal = this.getParameterByName(param)

      if (utmVal && utmVal.length > 0) {
        if (i === 0) {
          utmParamToAppendToLink += `?${param}=${utmVal}`
        } else {
          utmParamToAppendToLink += `&${param}=${utmVal}`
        }
      } else if (param === 'utm_source') {
        utmParamToAppendToLink += `?${param}=website`
      } else if (param === 'utm_medium') {
        utmParamToAppendToLink += `&${param}=blog`
      }

      if (param === 'utm_campaign') {
        utmParamToAppendToLink += `&${param}=${pos}`
      }
    }

    return utmParamToAppendToLink
  }

  render() {
    return null
  }
}

export default BlogUtm
